import styled from 'styled-components';
import { Button } from 'antd';

export const MainBarWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const FlexRight = styled.div`
  margin-left: auto;
`;

export const StyledButton = styled(Button)`
  margin-left: 6px;
  margin-right: 6px;
`;
